export const filterSlice = (set) => ({
  filtersSelect: [],
  priceRange: {
    min: '',
    max: '',
  },

  addFilter: (newFilter) => {
    set((state) => ({
      filtersSelect: [...state.filtersSelect, newFilter],
    }));
  },

  removeFilter: (filter) => {
    set((state) => ({
      filtersSelect: state.filtersSelect.filter((item) => item !== filter),
    }));
  },

  setPriceMin: (value) => {
    set((state) => ({
      priceRange: { ...state.priceRange, min: value },
    }));
  },

  setPriceMax: (value) => {
    set((state) => ({
      priceRange: { ...state.priceRange, max: value },
    }));
  },

  clearPriceRange: () => {
    set({ priceRange: { min: '', max: '' } });
  },

  clearFilters: () =>
    set({
      filtersSelect: [],
      priceRange: { min: '', max: '' },
    }),
});
